import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { WorkflowTemplate } from 'app/models/workflow-template';
import { Globals } from 'app/services/globals'
import { WorkflowStepCompletion } from 'app/models/workflow-step-completion';
import { WorkflowAutoUpload } from 'app/models/workflow-auto-upload';
import { WorkflowAutoEmail } from 'app/models/workflow-auto-email';

@Injectable({ providedIn: 'root' })
export class WorkflowAutoEmailService {

    constructor(private http: HttpClient, private globals: Globals) { }    

    addWorkflowAutoEmail(workflowStepCompletionId: number, email: WorkflowAutoEmail){
        return this.http.post<WorkflowAutoEmail>(`${this.globals.api_base_url}/workflow-step-completion/${workflowStepCompletionId}/auto-email`, email);
    }

    getWorkflowAutoEmails(workflowStepCompletionId: number){
        return this.http.get<WorkflowAutoEmail[]>(`${this.globals.api_base_url}/workflow-step-completion/${workflowStepCompletionId}/auto-emails`);
    }
    
    editWorkflowAutoEmail(email: WorkflowAutoEmail){
        return this.http.put<WorkflowAutoEmail>(`${this.globals.api_base_url}/workflow-auto-email/${email.id}`, email);
    }
    
    deleteWorkflowAutoEmail(emailId: number){
        return this.http.delete<WorkflowAutoEmail[]>(`${this.globals.api_base_url}/workflow-auto-email/${emailId}`);
    }

   
}